import { media } from '@/styles/Qtheme';
import styled from 'styled-components';

export const Container = styled.div<{ isDarkmode: boolean; isMobile: boolean }>`
  padding: 36px;
  background-color: ${({ isDarkmode }) => (isDarkmode ? '#191A19' : '#E8EBEA')};
  border-radius: 8px;

  display: flex;
  flex-direction: ${({ isMobile }) => (isMobile ? 'column' : 'row')};
  gap: ${({ isMobile }) => (isMobile ? '24px' : '76px')};
`;

export const ContainerWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const DesContent = styled.ul`
  flex: 1;
  width: 100%;
  list-style: none;
  margin: 0;

  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-size: 18px;

  @media ${media.tablet} {
    font-size: 16px;
  }

  @media ${media.mobile} {
    font-size: 14px;
  }
`;

export const DesContentItem = styled.li<{ isDarkmode: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  width: 100%;
  box-sizing: border-box;
  border: ${({ isDarkmode }) =>
    isDarkmode ? `1px solid #333333` : `1px solid #D1D1D1`};
  border-radius: 8px;
  background: ${({ isDarkmode }) => (isDarkmode ? `#1F1F1F` : `#F0F0F0`)};
  box-shadow: ${({ isDarkmode }) =>
    isDarkmode ? '0px 2px 16px 0px #00000066' : '0px 2px 16px 0px #0000000F'};
`;

// Left coin/icon wrapper
export const DesItemIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  background: transparent;
`;

// Reward green badge like "400 USDT 보상"
export const RewardBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 20px;

  color: ${({ theme }) => theme.text};
  font-weight: 700;

  @media ${media.mobile} {
    font-size: 16px;
  }
`;

// Small condition text under the badge
export const ConditionText = styled.div`
  color: ${({ theme }) => theme.COLORS.sectionDesc};
  font-size: 16px;

  @media ${media.mobile} {
    font-size: 14px;
  }
`;

export const SectionDivider = styled.div<{ isDarkmode: boolean }>`
  height: 1px;
  width: 100%;
  background: ${({ isDarkmode }) => (isDarkmode ? '#2A2B2D' : '#C2D3CC')};
  margin: 18px 0;
`;

export const ExternalTabButton = styled.button<{ isDarkmode: boolean }>`
  padding: 13px 14px;
  min-width: 180px;
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 0px 0px 10px 10px;
  background: ${({ isDarkmode }) => (isDarkmode ? '#141414' : '#D8D8D8')};
  color: ${({ isDarkmode }) => (isDarkmode ? '#FFFFFF' : '#212121')};
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  z-index: 0;

  span {
    display: inline-block;
    font-weight: 400;
    font-size: 16px;
  }
`;

export const GaugeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
`;

export const GaugeItem = styled.div<{ isDarkmode: boolean }>`
  background-color: ${({ isDarkmode }) =>
    isDarkmode ? 'rgba(31, 55, 45, 0.2)' : 'rgba(31, 55, 45, 0.05)'};
  border-radius: 8px;
  padding: 32px 44px;
  gap: 20px;

  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const GaugeItemTitle = styled.div`
  font-size: 16px;
  line-height: 1.25;
  color: ${({ theme }) => theme.COLORS.sectionDesc};

  @media ${media.mobile} {
    font-size: 14px;
  }
`;

export const GaugeItemDes = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  font-size: 36px;
  font-weight: 600;

  > img {
    width: 32px;
    height: 32px;

    @media ${media.mobile} {
      width: 28px;
      height: 28px;
    }
  }

  @media ${media.mobile} {
    font-size: 24px;
  }
`;

export const ProgressNumberWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 24px;

  @media ${media.mobile} {
    height: 13px;
  }
`;

export const ProgressNumberTag = styled.div<{
  left: number;
  isFirst?: boolean;
  isLast?: boolean;
}>`
  position: absolute;
  left: ${({ left }) => left}%;
  transform: ${({ isFirst, isLast }) =>
    isFirst ? 'none' : isLast ? 'translateX(-100%)' : 'translateX(-50%)'};
  white-space: nowrap;
  font-size: 16px;
  font-weight: 700;

  @media ${media.mobile} {
    font-size: 11px;
  }
`;

export const DisabledRewardButton = styled.button`
  align-self: flex-start;
  width: 116px;
  height: 46px;
  border-radius: 4px;
  border: none;
  background: #0abb76;
  color: #fff;
  font-weight: 700;
  font-family: 'Pretendard', sans-serif;
  font-size: 16px;
  white-space: nowrap;

  @media ${media.mobile} {
    font-size: 14px;
  }
`;

export const LockOverlay = styled.div<{ isDarkmode: boolean }>`
  position: absolute;
  inset: 0;
  border-radius: 8px;
  background: ${({ isDarkmode }) =>
    isDarkmode ? 'rgba(0, 0, 0, 0.45)' : 'rgba(255, 255, 255, 0.45)'};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  z-index: 2;
`;

export const LockText = styled.div<{ isDarkmode: boolean }>`
  padding: 12px 18px;
  border-radius: 10px;
  background: ${({ isDarkmode }) =>
    isDarkmode ? 'rgba(20, 20, 20, 0.95)' : 'rgba(0, 0, 0, 0.85)'};
  color: #ffffff;
  font-weight: 800;
  font-size: 18px;
  letter-spacing: 0.2px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.35);

  @media ${media.tablet} {
    font-size: 16px;
  }

  @media ${media.mobile} {
    font-size: 14px;
  }
`;

export const RewardHeaderSection = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: ${({ isMobile }) => (isMobile ? 'column' : 'row')};
  gap: ${({ isMobile }) => (isMobile ? '24px' : '80px')};
  align-items: ${({ isMobile }) => (isMobile ? 'center' : 'flex-start')};
  padding-left: ${({ isMobile }) => (isMobile ? '0' : '40px')};
  width: ${({ isMobile }) => (isMobile ? '100%' : 'auto')};

  @media ${media.tablet} {
    gap: ${({ isMobile }) => (isMobile ? '20px' : '60px')};
    padding-left: ${({ isMobile }) => (isMobile ? '0' : '40px')};
  }
`;

export const RewardInfoColumn = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-bottom: ${({ isMobile }) => (isMobile ? '16px' : '0')};
  width: ${({ isMobile }) => (isMobile ? '100%' : 'auto')};
  max-width: ${({ isMobile }) => (isMobile ? '100%' : '280px')};
`;

export const RewardTitle = styled.div<{
  isMobile: boolean;
  isDarkMode: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: ${({ isMobile }) => (isMobile ? '18px' : '24px')};
  font-weight: 700;
  text-align: center;
  margin-top: ${({ isMobile }) => (isMobile ? '0' : '32px')};
  color: ${({ isDarkMode }) => (isDarkMode ? '#ffffff' : '#212121')};
  line-height: 1.5;
  letter-spacing: -0.02em;
  white-space: nowrap;

  @media ${media.tablet} {
    font-size: ${({ isMobile }) => (isMobile ? '18px' : '24px')};
    margin-top: ${({ isMobile }) => (isMobile ? '0' : '24px')};
  }
`;

export const RewardAmountText = styled.span<{ theme: any; isMobile: boolean }>`
  color: ${({ theme }) => theme.COLORS.greenText};
  font-weight: 700;
  font-size: ${({ isMobile }) => (isMobile ? '22px' : '28px')};
  white-space: nowrap;
`;

export const RewardDescription = styled.div<{ isMobile: boolean }>`
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  width: 100%;
  max-width: ${({ isMobile }) => (isMobile ? '280px' : '320px')};
  line-height: ${({ isMobile }) => (isMobile ? '20px' : '26px')};
  color: ${({ theme }) => theme.COLORS.sectionDesc || 'inherit'};
  opacity: 0.9;

  @media ${media.tablet} {
    font-size: ${({ isMobile }) => (isMobile ? '14px' : '15px')};
    line-height: ${({ isMobile }) => (isMobile ? '18px' : '24px')};
  }
`;

export const CoinImage = styled.img<{ isMobile: boolean }>`
  width: ${({ isMobile }) => (isMobile ? '200px' : '280px')};
  height: auto;
  aspect-ratio: 1;
  margin-top: ${({ isMobile }) => (isMobile ? '16px' : '32px')};
  object-fit: contain;
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.1));

  @media ${media.tablet} {
    width: ${({ isMobile }) => (isMobile ? '180px' : '240px')};
    margin-top: ${({ isMobile }) => (isMobile ? '12px' : '24px')};
  }
`;
